import { useSelector } from "react-redux";
import { selectFont } from "../store/DynamicStyle/font_selectors";

const useFontData = () => {
  const font = useSelector(selectFont);

  return {
    HeaderSize: font[0]?.header_size,
    Contact: font[0]?.contact || "(800) 723-4290",
    Email: font[0]?.email || "support@triagelogic.com",
  };
};


export default useFontData;




